import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link, useParams } from "react-router-dom";
import { BsPersonFill } from "react-icons/bs";

function SellerApprovalView() {
  const { company_id } = useParams(); // Get the seller ID from the URL
  const [seller, setSeller] = useState({});
  const [products, setProducts] = useState([]);

  // Fetch seller details and products
  useEffect(() => {
    const fetchSellerDetails = async () => {
      try {
        const response = await USER_URL.get(`/accounts/admin/companies/${company_id}/`);
        console.log("Response:", response.data); 
    
        // No nested `data` field, so use response.data directly
        const sellerData = response.data.data.company_details;
        const productData =response.data.data.products

    
        // Set seller with the entire object
        setSeller(sellerData || {});  
    
        // No products in the response, so set an empty array
        setProducts(productData);
      } catch (error) {
        console.error("Error fetching seller details:", error.message || error);
      }
    };
    

    fetchSellerDetails();
  }, []);console.log(seller);
  

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="flex items-center space-x-6 mb-8">
        {/* Profile Avatar */}
        <div className="w-24 h-24 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer">
          <BsPersonFill className="text-gray-500 size-20" />
        </div>

        {/* Logo */}
        <div className="w-24 h-24 shadow-md flex items-center justify-center border-2 border-gray-300 rounded-lg">
          {seller.logo ? (
            <img
              src={
                seller.logo instanceof File
                  ? URL.createObjectURL(seller.logo) // Show selected logo file
                  : `${BASE_URL}${seller.logo}` // Show logo from API
              }
              alt="Seller Logo"
              className="w-full h-full object-contain rounded-lg"
            />
          ) : (
            <span className="text-gray-500 text-xs">No Logo</span>
          )}
        </div>

        {/* Approval Status */}
        <div
  className={`mt-auto pt-2 font-semibold ${
    seller.status === "Approved" ? "text-green-500" :
    seller.status === "Rejected" ? "text-red-500" :
    seller.status === "Pending" ? "text-yellow-500" :
    "text-gray-500"  // Default color for unknown status
  }`}
>
  {seller.status}
</div>

      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        {/* Personal Info Section */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Personal Info</h2>
          <div className="space-y-4">
  <div className="p-4 bg-white border rounded-lg shadow-sm">
    <span className="block text-sm font-medium text-gray-600 mb-1">Name</span>
    <p className="text-lg font-semibold text-gray-800">
      {seller.name || "Not Provided"}
    </p>
  </div>

  <div className="p-4 bg-white border rounded-lg shadow-sm">
    <span className="block text-sm font-medium text-gray-600 mb-1">Email</span>
    <p className="text-lg font-semibold text-gray-800">
      {seller.email || "Email Unavailable"}
    </p>
  </div>

  <div className="p-4 bg-white border rounded-lg shadow-sm">
    <span className="block text-sm font-medium text-gray-600 mb-1">Phone Number</span>
    <p className="text-lg font-semibold text-gray-800">
      {seller.phone || "Phone Not Provided"}
    </p>
  </div>
</div>

        </div>

        {/* Company Info Section */}
        <div>
          <h2 className="text-2xl font-bold mb-4">Company Info</h2>
          <div className="space-y-4">
          <div className="p-4 bg-white border rounded-lg shadow-sm">
    <span className="block text-sm font-medium text-gray-600 mb-1">Company Name</span>
    <p className="text-lg font-semibold text-gray-800">
      {seller.name || "Not Provided"}
    </p>
  </div>

  <div className="p-4 bg-white border rounded-lg shadow-sm">
    <span className="block text-sm font-medium text-gray-600 mb-1">Company Location</span>
    <p className="text-lg font-semibold text-gray-800">
      {seller.location || "Location Unavailable"}
    </p>
  </div>

  <div className="p-4 bg-white border rounded-lg shadow-sm">
    <span className="block text-sm font-medium text-gray-600 mb-1">Company Email</span>
    <p className="text-lg font-semibold text-gray-800">
      {seller.mail_id || "Email Not Provided"}
    </p>
  </div>
          </div>
        </div>
      </div>

      {/* Seller Products Section */}
      <div className="mb-8">
        <h2 className="text-lg font-bold mb-4">Seller Products</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-lg shadow-sm">
            <thead>
              <tr>
                {["Item No", "Product Code", "Name", "Stock", "Price", "Image"].map(
                  (header, index) => (
                  <th
                    key={index}
                    className="py-3 px-4 text-left text-sm font-medium text-green-500"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {products.length > 0 ? (
                products.map((product, index) => (
                  <tr key={product.id}>
                    <td className="py-3 px-4 text-sm">
                      <div className="border rounded-lg px-4 py-2">{index + 1}</div>
                    </td>
                    <td className="py-3 px-4 text-sm">
                      <div className="border rounded-lg px-4 py-2">
                        {product.product_code || "N/A"}
                      </div>
                    </td>
                    <td className="py-3 px-4 text-sm">
                      <div className="border rounded-lg px-4 py-2">{product.name || "N/A"}</div>
                    </td>
                    <td className="py-3 px-4 text-sm">
                      <div className="border rounded-lg px-4 py-2">{product.stock || "N/A"}</div>
                    </td>
                    <td className="py-3 px-4 text-sm">
                      <div className="border rounded-lg px-4 py-2">{product.price || "N/A"}</div>
                    </td>
                    <td className="p-2">
                                       <Link to={`/admin/product-details/${product.id}`}
                                         className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100"
                                       >
                                         VIEW
                                       </Link>
                                     </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-gray-500">
                    No products available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SellerApprovalView;